import { useCallback, useEffect, useRef, useState } from "react";
import { createUpdateLeave, getLeaveRequestTypes, getLeavesType } from "../../../services/user";
import ErrorService from "../../../services/errorService";
import { InputWrapper } from "../../../pages/auth/Login.style";
import Select from "../../select/select";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import DatePickerComponent from "../../datepicker/DatePicker";
import { convertToBase64 } from "../../../utils";
import Upload from "../../../assets/icons/upload";

export default function RequestForm(editData) {

    let initialData = {
        id: editData.id || 0,
        staffId: editData.staffId || 0,
        schoolId: editData.schoolId || 0,
        requestTypeId: editData.requestTypeId || 0,
        leaveTypeId: editData.leaveTypeId || 0,
        startDate: editData.startDate || null,
        endDate: editData.endDate || null,
        message: editData.message || '',
        documents: []
    }

    const fileInputRef = useRef(null);
    const [form, setForm] = useState(initialData);
    const [requestType, setRequestType] = useState("");
    const [requests, setRequests] = useState([]);
    const [requestLeavesType, setRequestLeavesType] = useState([]);
    const [leaveType, setLeaveType] = useState("");
    const [selectedPic, setSelectedPic] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingUploading, setLoadingUploading] = useState(false);
    const { admToken, user } = useSelector((state) => state.auth);
    const [imagePreviewPic, setImagePreviewPic] = useState([]);
    const [base64Files, setBase64Files] = useState([]);

    const getRequest = useCallback(async () => {
        try {
            setLoading(true);
            const res = await getLeaveRequestTypes(admToken);

            if (res.status && res.statusCode === 2) {
                setRequests(res.data);
            } else {
                ErrorService.displayErrorAlert(res.data);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }, [admToken]);

    const getLeaves = useCallback(async () => {
        try {
            setLoading(true);
            const res = await getLeavesType(admToken);

            if (res.status && res.statusCode === 2) {
                setRequestLeavesType(res.data);
            } else {
                ErrorService.displayErrorAlert(res.data);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }, [admToken]);

    useEffect(() => {
        getRequest();
        getLeaves();
    }, [getRequest, getLeaves])

    const handleRequestType = (val) => {
        setRequestType(val.name);

        setLeaveType("");

        if (val.name === "Leave") {
            setShowForm(false);
        } else {
            setShowForm(true);
        }

        setForm({ ...form, requestTypeId: val.id });
    };

    const handleLeaveType = (val) => {
        setLeaveType(val);
        setShowForm(true);

        setForm({ ...form, leaveTypeId: val.id });
    };

    // useEffect(() => {
    //     if (!editData) return;

    //     setForm({
    //         startDate: editData.startDate,
    //         endDate: editData.endDate,
    //         message: editData.message,
    //         documents: editData.documents || [],
    //         requestTypeId: editData.requestTypeId,
    //         leaveTypeId: editData.leaveTypeId || "",
    //     });

    //     const req = requests.find(
    //         (item) => item.id === editData.requestTypeId
    //     );
    //     setRequestType(req?.name || "");

    //     if (req?.name === "Leave") {
    //         const leave = requestLeavesType.find(
    //             (x) => x.id === editData.leaveTypeId
    //         );
    //         setLeaveType(leave || "");
    //         setShowForm(true);
    //     } else {
    //         setLeaveType("");
    //         setShowForm(true);
    //     }
    // }, [editData, requestType, requestLeavesType]);


    const handleUploadFilesClick = () => {
        fileInputRef.current?.click();
    };

    const handleUploadFiles = async (event) => {
        const files = event.target.files;
        if (!files) return;

        imagePreviewPic.forEach((url) => URL.revokeObjectURL(url));

        const fileArray = Array.from(files);
        const previewUrls = fileArray.map((file) => URL.createObjectURL(file));

        const base64Array = await Promise.all(fileArray.map((file) => convertToBase64(file)));

        setSelectedPic(fileArray);
        setImagePreviewPic(previewUrls);
        setBase64Files(base64Array);
    };

    const handleUpdate = async () => {
        try {
            const payload = {
                id: 0,
                staffId: user.staffId,
                schoolId: user.schoolId,
                requestTypeId: form.requestTypeId || 0,
                leaveTypeId: form.leaveTypeId || 0,
                startDate: form.startDate,
                endDate: form.endDate,
                message: form.message,
                documents: base64Files
            }

            setLoadingUploading(true)
            const res = await createUpdateLeave(admToken, payload, user?.staffId);
            if (res.status && res.statusCode === 2) {
                toast.success(res.message);
                setForm({
                    id: 0,
                    staffId: 0,
                    schoolId: 0,
                    requestTypeId: 0,
                    leaveTypeId: 0,
                    startDate: null,
                    endDate: null,
                    message: '',
                    documents: []
                });
            } else {
                toast.error(res.message);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingUploading(false)
        }
    };

    return (
        <div className="w-full max-w-2xl mx-auto p-6 min-h-screen">
            <h2 className="text-xl font-semibold mb-4">REQUESTS</h2>

            <div className="flex flex-col md:flex-row items-center gap-10 w-full">
                <div className="w-full md:w-1/2">
                    <label className="block font-medium mb-1">Request Type</label>
                    <Select
                        title="Request Type"
                        index="name"
                        selected={form.requestTypeId}
                        thirdOption="id"
                        options={requests}
                        setSelected={handleRequestType}
                        styles={{ width: "100%" }}
                    />
                </div>

                {requestType === "Leave" && (
                    <div className="mb-1 aniate-fadeIn w-full">
                        <label className="block font-medium mb-1">Select Leave Type</label>
                        <Select
                            title="Leaves Type"
                            index="name"
                            selected={form.leaveTypeId}
                            thirdOption="id"
                            options={requestLeavesType}
                            setSelected={handleLeaveType}
                        />
                    </div>
                )}

            </div>

            {showForm && (
                <div className="mt-6 bg-white p-5 border border-primary shadow rounded-xl animate-fadeIn overflow-auto">
                    <h3 className="text-lg font-semibold mb-4">Request Details</h3>

                    <div className="flex flex-col md:flex-row items-center gap-10 w-full">
                        <InputWrapper>
                            <label htmlFor="">Start Date</label>
                            <DatePickerComponent
                                selected={form.startDate ? new Date(form.startDate) : null}
                                setSelected={(val) => setForm({ ...form, startDate: val ? val.toISOString() : null })}
                                disabled={loading}
                            />
                        </InputWrapper>

                        <InputWrapper>
                            <label htmlFor="">End Date</label>
                            <DatePickerComponent
                                selected={form.endDate ? new Date(form.endDate) : null}
                                setSelected={(val) => setForm({ ...form, endDate: val ? val.toISOString() : null })}
                                disabled={loading}
                            />
                        </InputWrapper>
                    </div>

                    {/* Message */}
                    <div className="my-4">
                        <label className="block font-medium mb-1">Message</label>
                        <textarea
                            className="w-full p-3 border rounded-lg"
                            rows={4}
                            placeholder="Write message..."
                            value={form.message}
                            onChange={(e) => setForm({ ...form, message: (e.target.value) })}
                        ></textarea>
                    </div>

                    {/* Required Documents */}
                    <InputWrapper>
                        <label htmlFor="">Attach Attachment (max 3- Pdf/jpeg)</label>
                        <div
                            className="relative w-28 h-28 md:w-full md:h-36 bg-gray-100 mt-2 mb-4"
                            onClick={handleUploadFilesClick}
                        >
                            <div className="h-full md:w-full md:h-36 bg-gray-100 flex items-center justify-center border border-dashed border-primary overflow-hidden rounded-lg">
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    onChange={handleUploadFiles}
                                    accept="Pdf/jpeg"
                                    multiple
                                    hidden
                                    disabled={loading}
                                />
                                {imagePreviewPic.length > 0 ? (
                                    <div className="flex gap-2 overflow-x-auto p-2">
                                        {imagePreviewPic.map((url, idx) => {
                                            const isPDF = selectedPic[idx]?.type === "application/pdf";

                                            return (
                                                <div
                                                    key={idx}
                                                    className="w-20 h-20 bg-white border rounded flex items-center justify-center text-xs font-semibold"
                                                >
                                                    {isPDF ? (
                                                        <span className="text-red-600">📄 PDF</span>
                                                    ) : (
                                                        <img
                                                            src={url}
                                                            alt={`preview-${idx}`}
                                                            className="h-full w-full object-cover rounded"
                                                        />
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div className="flex flex-col space-y-6 justify-center py-10 items-center p-5 mb-2">
                                        <Upload />
                                        <label>Click to upload your Images/PDF</label>
                                    </div>
                                )}
                            </div>
                        </div>
                    </InputWrapper>

                    <button
                        disabled={loadingUploading}
                        className="bg-primary text-white w-full p-3 rounded-lg mt-3 disabled:cursor-not-allowed! cursor-pointer disabled:opacity-60"
                        onClick={handleUpdate}
                    >
                        {loadingUploading ? "submitting.." : "Submit Request"}
                    </button>
                </div>
            )}
        </div>
    );
}
